import { render, staticRenderFns } from "./internetError.vue?vue&type=template&id=444d5e38&scoped=true"
import script from "./internetError.vue?vue&type=script&lang=js"
export * from "./internetError.vue?vue&type=script&lang=js"
import style0 from "./internetError.vue?vue&type=style&index=0&id=444d5e38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "444d5e38",
  null
  
)

export default component.exports